
const AI_AN = 'AI_AN';
const ALIMONY = 'ALIMONY';
const BUSINESS = 'BUSINESS';
const CAPITAL_GAIN = 'CAPITAL_GAIN';
const DUMMY = 'DUMMY';
const EARLY_WITHDRAWAL_PENALTIES = 'EARLY_WITHDRAWAL_PENALTIES';
const EDUCATOR = 'EDUCATOR';
const DEDUCTIONS = 'deductions';
const EXPENSES = 'expenses';
const INCOMES = 'incomes';
const FARMING_FISHING = 'FARMING_FISHING';
const HEALTH_SAVING_ACCOUNT = 'HEALTH_SAVING_ACCOUNT';
const INVESTMENT = 'INVESTMENT';
const IRA = 'IRA';
const JOB = 'JOB';
const MOVING = 'MOVING';
const OTHER = 'OTHER';
const PENSION = 'PENSION';
const RENTAL_ROYALTY = 'RENTAL_ROYALTY';
const RETIREMENT = 'RETIREMENT';
const SCHOLARSHIP = 'SCHOLARSHIP';
const SELF_EMPLOYMENT = 'SELF_EMPLOYMENT';
const SELF_EMPLOYED_HEALTH_INSURANCE = 'SELF_EMPLOYED_HEALTH_INSURANCE';
const SELF_EMPLOYED_PLANS = 'SELF_EMPLOYED_PLANS';
const SELF_EMPLOYMENT_TAX = 'SELF_EMPLOYMENT_TAX';
const SOCIAL_SECURITY_DISABILITY = 'SOCIAL_SECURITY_DISABILITY';
const STUDENT_LOAN_INTEREST = 'STUDENT_LOAN_INTEREST';
const UNEMPLOYMENT = 'UNEMPLOYMENT';
const UNSPECIFIED = 'UNSPECIFIED';


// Subtypes

const CANCELED_DEBT = 'CANCELED_DEBT';
const CASH_SUPPORT = 'CASH_SUPPORT';
const COURT_AWARD = 'COURT_AWARD';
const GAMBLING_PRIZE_AWARD = 'GAMBLING_PRIZE_AWARD';
const JURY_DUTY_PAY = 'JURY_DUTY_PAY';
const OTHER_INCOME = 'OTHER_INCOME';


export const EXPENSE_TYPES  = {
    ALIMONY,
    BUSINESS,
    EARLY_WITHDRAWAL_PENALTIES,
    EDUCATOR,
    HEALTH_SAVING_ACCOUNT,
    IRA,
    MOVING,
    OTHER,
    SELF_EMPLOYED_HEALTH_INSURANCE,
    SELF_EMPLOYED_PLANS,
    SELF_EMPLOYMENT_TAX,
    STUDENT_LOAN_INTEREST,
    UNSPECIFIED
};

export const INCOME_TYPES = {
    AI_AN,
    ALIMONY,
    CAPITAL_GAIN,
    DUMMY,
    FARMING_FISHING,
    INVESTMENT,
    JOB,
    OTHER,
    PENSION,
    RENTAL_ROYALTY,
    RETIREMENT,
    SCHOLARSHIP,
    SELF_EMPLOYMENT,
    SOCIAL_SECURITY_DISABILITY,
    UNEMPLOYMENT,
    UNSPECIFIED
};

export const OTHER_INCOME_TYPES = {
    CANCELED_DEBT,
    CASH_SUPPORT,
    COURT_AWARD,
    GAMBLING_PRIZE_AWARD,
    JURY_DUTY_PAY,
    OTHER_INCOME
};

export const PARAMETER_TYPES= {
    DEDUCTIONS,
    EXPENSES,
    INCOMES
};